import React from 'react';
import { ContainerP } from './style.css';
import Share from '../Sharer';

const Parrafo = (props) => {
    return (
        <ContainerP>
            <p
             data-sal="slide-up"
             data-sal-delay="2000"
             data-sal-easing="ease"
            >{props.texto}</p>
        </ContainerP>
    );
}

export default Parrafo;